var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "countdown-wrapper" }, [
    _c("div", { staticClass: "hours-wrapper" }, [
      _c("div", { staticClass: "display-box hour" }, [
        _vm._v(_vm._s(_vm.timerHour)),
      ]),
      _c("div", { staticClass: "label" }, [
        _vm._v(" " + _vm._s(_vm.$t("Hrs")) + " "),
      ]),
    ]),
    _c("div", { staticClass: "min-wrapper" }, [
      _c("div", { staticClass: "display-box min" }, [
        _vm._v(_vm._s(_vm.timerMinite)),
      ]),
      _c("div", { staticClass: "label" }, [
        _vm._v(" " + _vm._s(_vm.$t("Min")) + " "),
      ]),
    ]),
    _c("div", { staticClass: "sec-wrapper" }, [
      _c("div", { staticClass: "display-box sec" }, [
        _vm._v(_vm._s(_vm.timerSecond)),
      ]),
      _c("div", { staticClass: "label" }, [
        _vm._v(" " + _vm._s(_vm.$t("Sec")) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }